import React from "react";
import API from "../../services/api";

function PopupRenderer({ popup }) {

  if (!popup || !popup.blocks) {
    return null;
  }

  const getSizeStyle = () => {

    switch (popup.size) {

      case "small":
        return { maxWidth: "350px" };

      case "medium":
        return { maxWidth: "600px" };

      case "large":
        return { maxWidth: "900px" };

      case "fullscreen":
        return {
          width: "100%",
          height: "100%"
        };

      default:
        return {};
    }
  };

  const handleClick = async (popupId) => {

    try {

      await API.put(
        `/popups/${popupId}/click`
      );

    } catch (error) {

      console.log(error);

    }
  };

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  
  return (

    <div
      className="popup-renderer"
      style={getSizeStyle()}
    >

      {popup.blocks.map((block) => {

        if (block.type === "text") {

          return (

            <div
              key={block.id}
              style={{
                color: block.color,
                fontSize: `${block.fontSize}px`,
                fontWeight: block.fontWeight,
                textAlign: block.textAlign,
                marginBottom: "12px"
              }}
            >

              {block.content}

            </div>

          );

        }

        if (block.type === "image") {

          console.log("BACKEND_URL =", BACKEND_URL);
console.log("IMAGE =", `${BACKEND_URL}${block.url}`);

          return (

 <div
    style={{
    
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      width: "100%",
     
      padding: "10px",

   
    }}
  >
            <img
              key={block.id}
                src={`${BACKEND_URL}${block.url}`}

              alt=""
              style={{
                width: `${block.width || 100}%`,
                maxHeight: "260px",
                minHeight: "180px",
                objectFit: "cover",
                borderRadius: "8px",
                marginBottom: "12px"
              }}
            />
      </div>
          );

        }

if (block.type === "video") {

  return (

    <video
      key={block.id}
      src={`${BACKEND_URL}${block.url}`}

      autoPlay
      loop
      muted
      playsInline

      controls={false}

      style={{
        width: `${block.width || 100}%`,
        borderRadius: "8px",
        marginBottom: "12px",
        maxHeight: "260px",
        minHeight: "180px",
        objectFit: "cover"
      }}
    />

  );

}

        if (block.type === "button") {

          return (

            <div
              key={block.id}
              style={{
                marginTop: "15px",
                textAlign: "center"
              }}
            >

              <a
                href={block.url}
                target={block.target || "_self"}
                rel="noreferrer"
                onClick={() =>
                  handleClick(popup._id)
                }
                style={{
                  display: "inline-block",
                  background: block.background || "#ff7b00",
                  color: block.color || "#fff",
                  padding: "12px 20px",
                  borderRadius: "8px",
                  textDecoration: "none",
                  fontWeight: "bold"
                }}
              >

                {block.label || "Bouton"}

              </a>

            </div>

          );

        }

        return null;

      })}

    </div>

  );

}

export default PopupRenderer;